// Older devices compatibility
import 'babel-polyfill'
import 'whatwg-fetch'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'

// VUE
import Vue from 'vue'
import vuetify from './themes/vuetify'
import App from './App'
import router from '@/router'
import store from '@/store'

// Importation de l'appui long
import { longpress } from 'modulevue'
import FastClick from 'fastclick'

// Codrova import for Vue
import VueCordova from 'vue-cordova'

// Importation global components
import Screen from './components/Screen'
import Scrollable from './components/Scrollable'
import PaymentBtn from './components/input/PaymentBtn'
import ActionBtn from './components/input/ActionBtn'
import Keyboard from './components/keyboard/Keyboard'
import KeyboardCode from './components/keyboard/KeyboardCode'
import BottomAction from './components/keyboard/BottomAction'
import Dialog from './components/modal/Dialog'

// Import and Use I18N plugin
import i18n from './lang/index'

import { TypeScanEnum } from '@/modules/Enums'
import { $alert } from '@/modules/Utils'

Vue.component('Screen', Screen)
Vue.component('Scrollable', Scrollable)
Vue.component('Keyboard', Keyboard)
Vue.component('KeyboardCode', KeyboardCode)
Vue.component('BottomAction', BottomAction)
Vue.component('UiDialog', Dialog)
Vue.component('PaymentBtn', PaymentBtn)
Vue.component('ActionBtn', ActionBtn)

// Utilisation de l'appui long
Vue.use(longpress, { duration: 2000 })

Vue.use(VueCordova, {
  optionTestKey: 'optionTestValue'
})

Vue.config.productionTip = false

// CORDOVA
var cordovaScript = document.createElement('script')
cordovaScript.setAttribute('type', 'text/javascript')
cordovaScript.setAttribute('src', 'cordova.js')
document.body.appendChild(cordovaScript)

document.addEventListener('deviceready', () => {
  // BLOCAGE DU BOUTON PHYSIQUE RETOUR
  document.addEventListener('backbutton', () => {}, false)

  // OS Platform
  window.IS_IOS = false
  window.IS_DESKTOP = false
  window.IS_ANDROID = false
  // Device
  window.IS_PAX = false
  window.IS_CISS_ANDROID = false
  window.IS_INGENICO = false
  window.IS_SUNMI = false

  const platform = device.platform.toLowerCase()
  if (platform === 'ios') {
    window.IS_IOS = true
    // Hide statusbar on start for IOS
    while (StatusBar.isVisible) {
      StatusBar.hide()
    }
    // Correction appui long sur IOS
    FastClick.attach(document.body)
  } else if (platform === 'browser') {
    window.IS_DESKTOP = true
    TypeScanEnum[4].show = true
  } else if (platform === 'android') {
    window.IS_ANDROID = true

    const manufacturer = device.manufacturer.toLowerCase()
    if (manufacturer === 'pax' || manufacturer === 'lephone') {
      window.IS_PAX = true
      TypeScanEnum[3].show = true
      // Get serial number
      Pax.getTermInfo((infos) => {
        if (infos.SN) {
          device.serial = infos.SN
        }
      })
    } else if (manufacturer === 'ingenico') {
      window.IS_INGENICO = true
      // Get serial number
      Ingenico.getSerialNumber(
        (serial) => { device.serial = serial },
        (error) => {
          $alert(
            'Erreur pendant la récupération du numéro de série',
            'warning',
            error
          )
        }
      )
    } else if (manufacturer === 'sunmi') {
      window.IS_SUNMI = true
    } else if (
      manufacturer === 'mobiwire' || manufacturer === 'mobiiot' ||
      manufacturer === 'ciontek' || manufacturer === 'qualcomm' ||
      manufacturer === 'rockchip'
    ) {
      window.IS_CISS_ANDROID = true
    }

    // Écriture des erreur JS dans un fichier de log
    // window.onerror = (error, url, line) => {
    //   FileHelper.write(`[ERROR] ${(new Date()).toISOString()} - ${error} - ${url} - ${line}\n`)
    // }
  }

  new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
